import { render, staticRenderFns } from "./harvest.vue?vue&type=template&id=20909d42&scoped=true"
import script from "./harvest.vue?vue&type=script&lang=js"
export * from "./harvest.vue?vue&type=script&lang=js"
import style0 from "./harvest.vue?vue&type=style&index=0&id=20909d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20909d42",
  null
  
)

export default component.exports